export default {
  MortgageCalculator: "{09387404-018F-4928-8B40-E9DC52FD8C9A}",
  DrivingDirections: "{622B1DEC-E4CC-4AE2-9BF9-0DF8653B4F28}",
  ClickToCall: "{84ECDCBA-E2E1-4E6C-B460-DC10DCF0EFA4}",
  ClickToText: "{75F079D5-AAFD-4981-9513-E87B0287DC27}",
  Email: "{CABA4BFF-45B8-45A6-86AF-91A9AEB1E19F}",
  BookAppointment: "{83E1C8CE-ADC8-4B95-B1AA-0E73D30C641D}",
  BookSelfGuidedTour: "{3A7CE669-B7C5-4D1A-B354-31ADAD130791}",
  MattamyHF: "{39BC9F29-54A5-40CB-A9BA-8202D52D260C}",
  Favorites: "{9058EAF5-B275-49A9-AE86-E2020B351967}",
  RegisterForUpdates: "{B077E2C4-5F72-4BB6-843F-8768D9771E7F}",
};
